import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { LanguageProvider } from "@/context/LanguageContext";
import { useSmoothScroll } from "@/hooks/useSmoothScroll";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import CasaSection from "@/components/CasaSection";
import EventiSection from "@/components/EventiSection";
import GalleriaSection from "@/components/GalleriaSection";
import LocationSection from "@/components/LocationSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import QuickContact from "@/components/QuickContact";
import LoginPage from "@/pages/LoginPage";
import AuthCallback from "@/pages/AuthCallback";
import AdminPage from "@/pages/AdminPage";

const PublicSite = () => {
  useSmoothScroll();

  return (
    <>
      <Header />
      <Hero />
      <Marquee />
      <CasaSection />
      <QuickContact />
      <EventiSection />
      <GalleriaSection />
      <LocationSection />
      <ContactSection />
      <Footer />
      <WhatsAppFloat />
    </>
  );
};

const AppRouter = () => {
  const location = useLocation();

  // Detect session_id in URL fragment synchronously (prevents race conditions)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<PublicSite />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/admin" element={<AdminPage />} />
    </Routes>
  );
};

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <Toaster />
      </div>
    </LanguageProvider>
  );
}

export default App;
